module.exports = __webpack_public_path__ + "img/trio-page-1-siltac.025dd809.jpg";